/* CONSTS INJECTION */
;
const PUBLIC_PATH="/assets/";
/* VARS INJECTION */
;
/* LETS INJECTION */
;
$(function () {
  var cooldown = function cooldown(callback, delay, _thisArg) {
    var lock = false;
    return function () {
      if (lock) return;
      lock = true;
      setTimeout(function () {
        lock = false;
      }, delay);
      callback.apply(_thisArg || this, [].slice.call(arguments));
    };
  };

  (function (targets, setups) {
    var screens = Object.keys(setups);
    var handle = cooldown(function () {
      var options = setups[screens[0]];
      screens.map(function (screen) {
        if (parseInt(screen) < window.screen.width) {
          options = setups[screen];
        }
      });
      $(targets).each(function () {
        var $this = $(this);
        if ($this.is('.slick-initialized')) $this.slick('unslick');
        $this.slick(options);
      });
    }, 250);
    handle();
    window.addEventListener('resize', handle);
  })(".galery1-slider, .galery2-slider", {
    "0": {
      appendArrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false
    },
    "768": {
      appendArrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      autoplay: 2000
    },
    "992": {
      appendArrows: false,
      rows: 2,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: 2000
    }
  });

  $('.menu-btn').on('click', function () {
    $('.menu-block').toggleClass('menu-block-list-active');
  });
});